<div class="container">
  <div class="row">
    <div class="col-md-6 col-xs-12">

      <div style="display: block;box-shadow: var(--theme-shadow); padding: 10px;">
        <!-- <canvas baseChart width="400" height="400" [datasets]="lineChartData" [labels]="lineChartLabels"
          [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend" chartType="line"
          [plugins]="lineChartPlugins">
        </canvas> -->
        <canvas baseChart width="400" height="400" [datasets]="lineChartData" [labels]="lineChartLabels"
          [options]="lineChartOptions" [legend]="lineChartLegend" chartType="line"
          [plugins]="lineChartPlugins">
        </canvas>
      </div>
    </div>
    <div class="col-md-6 col-xs-12">
      <div style="display: block;box-shadow: var(--theme-shadow); padding: 10px;">
      <google-chart [data]="geoChart" *ngIf=mapReady></google-chart>
      </div>
    </div>
  </div>
</div>